module.exports = __webpack_public_path__ + "static/img/3.26a449f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news15/3.png
// module id = yoNR
// module chunks = 1